import sittingPaul from './sittingPaul';

export default {
  sittingPaul,
}
